<template>
  <div class="jumping">
    <Spinner />
  </div>
</template>

<script>
import Spinner from '@/components/shared/Spinner'
export default {
  name: 'externalLink',
  components: {
    Spinner,
  },
  beforeRouteEnter(to, from, next) {
    console.log('externalLinkPage', from)
    next(vm => {
      const link = vm.$route.params.link
      console.log('外部連結網址為: ', link)
      console.log(
        '是從哪裡跳到此中繼頁的？（curation：首頁輪播策展自訂版型，newscontentpage：軟文單一文章頁）答案： ',
        from.name
      )
      if (!link) {
        console.log('無連結，返回前頁')
        vm.$router.go(-1)
      } else if (
        link.indexOf(window.location.origin) == -1 &&
        window['host_externalUrl'] != null
      ) {
        console.log('有連結，打開手機原生瀏覽器 APP 並打開該網址')
        window['host_externalUrl'](link)
        if (from.name === 'curation') {
          console.log(
            '若是從「首頁輪播策展自訂版型」點過來的，打開網址後，台新 APP 自動返回首頁輪播策展自訂版型所在的首頁'
          )
          vm.$router.replace({ path: '/' })
        } else if (from.name === 'newscontentpage') {
          console.log(
            '若是從「軟文單一文章頁」點過來的，打開網址後，台新 APP 自動返回原單一文章頁'
          )
          vm.$router.replace({ path: `${from.path}` })
        }
      } else {
        console.log('有連結，直接在台新 APP 內打開外部網址')
        window.location.replace(link)
        // location.href = link
      }
    })
  },
}
</script>

<style lang="scss" scoped>
.jumping {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  flex-flow: column;
  flex: 1 1 auto;
  background-color: #fff;
  margin-bottom: -78px;
}
</style>
